import { createSelector } from '@ngrx/store';
import { ITravelCarHireSubBooking } from '@shared/shared/interfaces/travel-car-hire.interfaces';
import { ITravelHotelSubBooking } from '@shared/shared/interfaces/travel-hotel.interfaces';
import { HOTEL_SUB_BOOKING } from 'app.config';
import * as fromFeature from '../reducers/';
import * as fromFlightSubBooking from '../reducers/travel-flight-sub-booking.reducers';

export const getTravelCarHireSubBookingFeatureState = createSelector(
  fromFeature.getTravelBookingState,
  (state: fromFeature.TravelBookingState) => state.travelCarHireSubBooking
);

export const getTravelHotelSubBookingFeatureState = createSelector(
  fromFeature.getTravelBookingState,
  (state: fromFeature.TravelBookingState) =>
    state.travelHotelSubBooking || JSON.parse(localStorage.getItem(HOTEL_SUB_BOOKING) ?? '')
);

export const getTravelFlightSubBookingFeatureState = createSelector(
  fromFeature.getTravelBookingState,
  (state: fromFeature.TravelBookingState) => state.travelFlightSubBooking
);

export const getTravelFlightSubBookingError = createSelector(
  getTravelFlightSubBookingFeatureState,
  (state: fromFlightSubBooking.FlightSubBookingState) => state.error
);

export const getTravelFlightSubBooking = createSelector(
  getTravelFlightSubBookingFeatureState,
  (state: fromFlightSubBooking.FlightSubBookingState) => state.subBooking
);

export const getTravelFlightSubBookingPatchTravellersState = createSelector(
  getTravelFlightSubBookingFeatureState,
  (state: fromFlightSubBooking.FlightSubBookingState) => state.travellerPatch
);

export const getTravelHotelSubBookingPatchTravellersState = createSelector(
  getTravelHotelSubBookingFeatureState,
  (state: ITravelHotelSubBooking) => state.travellerPatch
);

export const getTravelCarSubBookingPatchTravellersState = createSelector(
  getTravelCarHireSubBookingFeatureState,
  (state: ITravelCarHireSubBooking) => state.travellerPatch
);
